import styled, {css} from "styled-components";

const Text = styled("p")<{bold?: boolean, size?: string}>`
    display: inline-block;
    color: ${(props) => props.theme.body};
    ${props => props.bold && css`
      font-weight: 600;
  `};
  font-size: ${(props) => props.size ? props.size : ""};


  @media screen and (max-width: 1440px) {
    font-size: ${(props) => props.size ? props.size : '12px'};
  }
`;

export default Text;